import { GenericFiltersProps } from 'src/modules/form/field/filters/types';
import React from 'react';
import { SmallScreenFilters } from 'src/modules/form/field/filters/SmallScreenFilters/SmallScreenFilters';
import { LargeScreenFilters } from 'src/modules/form/field/filters/LargeScreenFilters/LargeScreenFilters';
import { Media } from 'react-breakpoints';
import { breakpoints } from 'src/utils/breakpoints';
import { Col, Row } from 'antd';
import { SearchCount } from 'src/modules/form/field/filters/SearchCount/SearchCount';
import classnames from 'classnames';

import styles from './Filters.module.scss';

export interface FiltersProps extends GenericFiltersProps {
  resultsCountKey: string;
  resultsCount: number;
  className?: string;
  largeScreenFiltersClassName?: string;
  searchCountClassName?: string;
}

export const Filters = ({
  className,
  form,
  filters,
  resultsCountKey,
  resultsCount,
  largeScreenFiltersClassName,
  searchCountClassName,
}: FiltersProps) => {
  return (
    <Media>
      {({ currentBreakpoint } = { currentBreakpoint: 'xs' }) => (
        <Row className={classnames(styles.filters, className)}>
          <Col xs={10} sm={16}>
            {breakpoints[currentBreakpoint] < breakpoints.md ? (
              <SmallScreenFilters key={'SmallScreenFilters'} form={form} filters={filters} />
            ) : (
              <LargeScreenFilters
                className={largeScreenFiltersClassName}
                key={'LargeScreenFilters'}
                form={form}
                filters={filters}
              />
            )}
          </Col>
          <Col xs={14} sm={8}>
            <SearchCount
              className={searchCountClassName}
              count={resultsCount}
              countKey={resultsCountKey}
            />
          </Col>
        </Row>
      )}
    </Media>
  );
};
